import { render } from "./RegistrationIng.vue?vue&type=template&id=c9281398&scoped=true"
import script from "./RegistrationIng.vue?vue&type=script&lang=js"
export * from "./RegistrationIng.vue?vue&type=script&lang=js"

import "@/assets/css/user/common.css?vue&type=style&index=0&id=c9281398&scoped=true&lang=css"
import "@/assets/css/user/pages/admin.css?vue&type=style&index=1&id=c9281398&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shcho\\Desktop\\home\\git\\test\\cloudpos.kiosk\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9281398"]])

export default __exports__